import { CSSProperties } from "react";
import {
  BREAKPOINTS,
  BREAKPOINTS_MAX_WIDTH
} from "./constants"
import { Breakpoint } from "./types";

export const getCurrentBreakpoint = (width: number): Breakpoint | undefined => {
  const keys = Object.keys(BREAKPOINTS);
  const currentBreakpoint = keys.find((key, index) => {
    if (index === 0) {
      return width < BREAKPOINTS[key as Breakpoint];
    }

    if (index === keys.length - 1) {
      return width >= BREAKPOINTS[key as Breakpoint];
    }

    return width >= BREAKPOINTS[key as Breakpoint] && width < BREAKPOINTS[keys[index + 1] as Breakpoint];
  })

  return currentBreakpoint as Breakpoint;
}

export const getCurrentBreakpointMaxWidth = (width: number): number | undefined => {
  const currentBreakpoint = getCurrentBreakpoint(width);

  if (currentBreakpoint) {
    return BREAKPOINTS_MAX_WIDTH[currentBreakpoint];
  }

  return;
}

export const isGreaterThanBreakpoint = (width: number, breakpoint: Breakpoint): boolean => {
  return width >= BREAKPOINTS[breakpoint];
}

export const isLessThanBreakpoint = (width: number, breakpoint: Breakpoint): boolean => {
  return width < BREAKPOINTS[breakpoint];
}

export const makeMediaQuery = (breakpoint: Breakpoint, type: 'min' | 'max', cssProps: CSSProperties): string => {
  const styles = Object.keys(cssProps).map((key) => {
    return `${key.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`)}: ${cssProps[key as keyof CSSProperties]};`;
  }).join(' ');


  return `@media (${type}-width: ${BREAKPOINTS[breakpoint]}px) { ${styles} }`;
}

export const getActiveBreakpoints = (width: number): Record<Breakpoint, boolean> => {
  const keys = Object.keys(BREAKPOINTS);
  const activeBreakpoints: Record<Breakpoint, boolean> = {
    xs: true,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false,
  };

  keys.forEach((breakpoint) => {
    const maxWidth = BREAKPOINTS[breakpoint as Breakpoint];

    if (width >= maxWidth) {
      activeBreakpoints[breakpoint as Breakpoint] = true;
    }
  })

  return activeBreakpoints;
}
